// extracted by mini-css-extract-plugin
export default {"boxWrapper":"E_YeZ","boxContent":"LKUCd"};